module.exports = __webpack_public_path__ + "media/images/4-50b38d2f4d59daefa578b76f34ae024e.png";